module.exports = "a33c51843b79b23a21ac5b3d71af14f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/menu.png
// module id = 86
// module chunks = 0